module.exports = __webpack_public_path__ + "static/media/water_leak.9c91c7b5.svg";